<template>
  <div class="SportHeader-styles-sport-wrapper">
    <div class="SportTitle-styles-sport">
      <img class="SportTitle-styles-sport-icon" :src="'/static/assets/img/'+sport.alias+'.png'" loading="lazy" width="24" height="24">
      {{ sport.name }}
    </div>
    <template v-if="list == 1">
      <template v-if="(sport.id == 1 || sport.id == 9 || sport.id == 17 || sport.id == 77) && onLive">
        <marketSelect :id="1" :sport="sport.id" default="5498" :live="onLive" />
        <marketSelect :id="2" :sport="sport.id" default="12553" :live="onLive" v-if="!$route.params.event" />
        <marketSelect :id="3" :sport="sport.id" default="5506" :live="onLive" v-if="!$route.params.event" />
        <marketSelect :id="4" :sport="sport.id" default="5500" :live="onLive" v-if="!$route.params.event" />
      </template>

      <template v-if="(sport.id == 1 || sport.id == 17 || sport.id == 77) && !onLive">
        <marketSelect :id="1" :sport="sport.id" default="5498" :live="onLive" />
        <marketSelect :id="2" :sport="sport.id" default="5499" :live="onLive" v-if="!$route.params.event" />
        <marketSelect :id="3" :sport="sport.id" default="5500" :live="onLive" v-if="!$route.params.event" />
        <marketSelect :id="4" :sport="sport.id" default="5508" :live="onLive" v-if="!$route.params.event" />
      </template>

      <template v-if="sport.id == 2">
        <marketSelect :id="5" :sport="sport.id" :default="4476" :live="onLive" />
        <marketSelect :id="6" :sport="sport.id" :default="4477" :live="onLive" v-show="!$route.params.event" />
        <marketSelect :id="7" :sport="sport.id" :default="4478" :live="onLive" v-show="!$route.params.event" />
        <marketSelect :id="8" :sport="sport.id" :default="4482" :live="onLive" v-show="!$route.params.event" />
      </template>

      <template v-if="sport.id == 3">
        <marketSelect :id="9" :sport="sport.id" :default="4476" :live="onLive" />
        <marketSelect :id="10" :sport="sport.id" :default="2445" :live="onLive" v-show="!$route.params.event" />
        <marketSelect :id="11" :sport="sport.id" :default="10633" :live="onLive" v-show="!$route.params.event" />
        <marketSelect :id="12" :sport="sport.id" :default="8690" :live="onLive" v-show="!$route.params.event" />
      </template>

      <template v-if="sport.id == 4">
        <marketSelect :id="13" :sport="sport.id" :default="5488" :live="onLive" />
        <marketSelect :id="14" :sport="sport.id" :default="5492" :live="onLive" v-show="!$route.params.event" />
        <marketSelect :id="15" :sport="sport.id" :default="5489" :live="onLive" v-show="!$route.params.event" />
        <marketSelect :id="16" :sport="sport.id" :default="8690" :live="onLive" v-show="!$route.params.event" />
      </template>

      <template v-if="sport.id == 99">
        <marketSelect :id="17" :sport="sport.id" :default="6549" :live="onLive" />
        <marketSelect :id="18" :sport="sport.id" :default="6552" :live="onLive" v-show="!$route.params.event" />
        <marketSelect :id="19" :sport="sport.id" :default="6546" :live="onLive" v-show="!$route.params.event" />
        <marketSelect :id="20" :sport="sport.id" :default="6546" :live="onLive" v-show="!$route.params.event" />
      </template>

      <template v-if="sport.id == 19">
        <marketSelect :id="21" :sport="sport.id" :default="399" :live="onLive" />
        <marketSelect :id="22" :sport="sport.id" :default="5481" :live="onLive" v-show="!$route.params.event" />
        <marketSelect :id="23" :sport="sport.id" :default="8692" :live="onLive" v-show="!$route.params.event" />
        <marketSelect :id="24" :sport="sport.id" :default="8694" :live="onLive" v-show="!$route.params.event" />
      </template>

      <template v-if="sport.id == 24">
        <marketSelect :id="25" :sport="sport.id" :default="6587" :live="onLive" />
        <marketSelect :id="26" :sport="sport.id" :default="6591" :live="onLive" v-show="!$route.params.event" />
        <marketSelect :id="27" :sport="sport.id" :default="6592" :live="onLive" v-show="!$route.params.event" />
        <marketSelect :id="28" :sport="sport.id" :default="8694" :live="onLive" v-show="!$route.params.event" />
      </template>

    </template>
     <template v-if="list == 2">
       <template v-if="sport.id == 1">
         <marketSelect :id="1" :sport="sport.id" default="5498" :live="onLive" />
         <marketSelect :id="2" :sport="sport.id" default="5500" :live="onLive" v-if="!$route.params.event" />
         <marketSelect :id="3" :sport="sport.id" default="5508" :live="onLive" v-if="!$route.params.event" />
       </template>

       <template v-if="sport.id == 2">
         <marketSelect :id="4" :sport="sport.id" :default="4477" :live="onLive" />
         <marketSelect :id="5" :sport="sport.id" :default="4482" :live="onLive" />
         <marketSelect :id="6" :sport="sport.id" :default="4478" :live="onLive" />
       </template>

       <template v-if="sport.id == 3">
         <marketSelect :id="7" :sport="sport.id" :default="8940" :live="onLive" />
         <marketSelect :id="8" :sport="sport.id" :default="2445" :live="onLive" />
         <marketSelect :id="9" :sport="sport.id" :default="8690" :live="onLive" />
       </template>

       <template v-if="sport.id == 4">
         <marketSelect :id="10" :sport="sport.id" :default="5488" :live="onLive" />
         <marketSelect :id="11" :sport="sport.id" :default="5492" :live="onLive" />
         <marketSelect :id="12" :sport="sport.id" :default="5489" :live="onLive" />
       </template>

       <template v-if="sport.id == 99">
         <marketSelect :id="13" :sport="sport.id" :default="6558" :live="onLive" />
         <marketSelect :id="14" :sport="sport.id" :default="6549" :live="onLive" />
         <marketSelect :id="15" :sport="sport.id" :default="6546" :live="onLive" />
       </template>

       <template v-if="sport.id == 19">
         <marketSelect :id="16" :sport="sport.id" :default="399" :live="onLive" />
         <marketSelect :id="17" :sport="sport.id" :default="5481" :live="onLive" />
         <marketSelect :id="18" :sport="sport.id" :default="8694" :live="onLive" />
       </template>

       <template v-if="sport.id == 24">
         <marketSelect :id="19" :sport="sport.id" :default="6587" :live="onLive" />
         <marketSelect :id="20" :sport="sport.id" :default="6591" :live="onLive" />
         <marketSelect :id="21" :sport="sport.id" :default="6592" :live="onLive" />
       </template>
       
     </template>


  </div>
</template>

<script>

    import marketSelect from "./marketSelect";
    export default {
        name: 'sportRow',
        components: {marketSelect},
        props: ['sport', 'extendedMarkets', 'list', 'onLive'],
        data () {
            return {
                t: this.$root.t,
                stickyEnabled: true,
            }
        },
        mounted() {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sportsbook/SportRow.vue